import Button from "../../../MentorDashboardV2/UI/Buttons";
import { SvgIcons } from "../../../SharedComponents/SvgIcons/SvgIcons";
import styles from "./style.module.css";

/**
 * Page-level failure: icon, title, message and an optional Retry.
 *
 * @param {string} [title]
 * @param {string} [message]
 * @param {Function} [onRetry] - when given, a "Try again" button is shown
 */
const ErrorState = ({
  title = "Couldn't load the report",
  message = "Something went wrong on our side. Please try again.",
  onRetry,
}) => (
  <div className={styles.wrap} role="alert">
    <SvgIcons name="error_circle_icon" width="48" height="48" className={styles.icon} />
    <h2 className={styles.title}>{title}</h2>
    <p className={styles.message}>{message}</p>
    {onRetry && (
      <Button variant="outline" color="primary" radius="soft" size="sm" onClick={onRetry}>
        Try again
      </Button>
    )}
  </div>
);

export default ErrorState;
